import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-brand">
          <h2>Pyro <span>Pot</span></h2>
          <p>Where Every Pot Tells a Story.</p>
        </div>
        
        <div className="footer-links">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#menu">Menu</a>
          <a href="#contact">Contact</a>
        </div>
        
        <div className="footer-social">
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-icon">IG</a>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-icon">FB</a>
          <a href="https://yelp.com" target="_blank" rel="noopener noreferrer" aria-label="Yelp" className="social-icon">Yelp</a>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Pyro Pot Restaurant. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
